




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { TextBlockViewModel } from '@/types/contentServerContract';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import tableHtmlService from './tableHtml.service';

@Component({
    components: { SmartHeadline }
})
export default class TextBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: TextBlockViewModel;

    @Prop({
        required: false,
        default: false,
        type: Boolean
    }) isFirstBlock!: boolean;

    private get backgroundColor() {
        return this.content.backgroundColor ? `#${this.content.backgroundColor}` : null;
    }

    private bodyText(html: string): string {
        return tableHtmlService.wrapTableInOuterDivs(html);
    }

    $refs!: Vue['$refs'] & {
        htmlContent: HTMLElement
    }

    private mounted() {
        tableHtmlService.registerTableOverflow(this.$refs.htmlContent);
    }

    private beforeDestroy() {
        tableHtmlService.unregisterTableOverflow(this.$refs.htmlContent);
    }
}
